import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import {
  medReviewConsentChecks,
  ClinicalServiceTypes,
  ailmentServices,
  getValidStep,
} from "../../../text/data";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteClinicalService,
  deleteMedicationReview,
  fetchClinicalServices,
  setClinicalServiceSteps,
  setDefaultSteps,
  updateClinicalService,
  updateMedicationReview,
} from "../../../../../redux/modules/clinical-services/actions";
import { calculateAgeYear, scrollY } from "../../../../../helpers/functions";
import CustomInput from "../../../../common/CustomInput";
import EndServiceModel from "../../../../common/EndServiceModel";
import {
  AlertConfirmationTypes,
  MinorAilmentStep,
} from "../../../../../helpers/constant";
import Signature from "../../../../common/signature/Signature";
import SubNavigation from "../../common/sub-navigation";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";

const ConsentForm = () => {
  const { clinicalServiceObj, clinicalServiceName, clinicalServiceSteps } =
    useSelector((state) => state.clinicalService);
  const { id, serviceId } = useParams();
    const navigate = useNavigate();
  const { patient } = useSelector((state) => state.patients);
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [openAgeAlert, setOpenAgeAlert] = useState(false);
  const [continueService, setContinueService] = useState(false);
  const dispatch = useDispatch();
  const [patientSign, setPatientSign] = useState(null);
  const [caregiverSign, setCaregiverSign] = useState(null);
  const [consentCheckData, setConsentCheckData] = useState([]);
  const [consentTitle, setConsentTitle] = useState(null);
  const [showSignature, setShowSignature] = useState(false);
  const [completeSubStep, setCompleteSubStep] = useState(false);
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);

  const [patientAcknowledgeIndicator, setPatientAcknowledgeIndicator] =
    useState(false);
  const [consentChecks, setConsentChecks] = useState([]);
  const [requireCaregiverSign, setRequireCaregiverSign] = useState(false);
  const [clinicalServiceStepsUpdated, setClinicalServiceStepsUpdated] =
    useState(false);
  const [alertConfirmation, setAlertConfirmation] = useState(0);
  const [alertExplaination, setAlertExplaination] = useState("");
  const [openDeleteServiceForMedical, setOpenDeleteServiceForMedical] =
    useState(false);

  useEffect(() => {
    if (clinicalServiceStepsUpdated) {
      onNext();
      setClinicalServiceStepsUpdated(false);
    }
  }, [clinicalServiceSteps, clinicalServiceStepsUpdated]);

  useEffect(() => {
    setServiceTypeView();
    setServiceTypeData();
  }, [clinicalServiceObj, clinicalServiceName]);

  const deleteService = () => {
    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      dispatch(deleteClinicalService(id, serviceId, navigate));
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      dispatch(deleteMedicationReview(id, serviceId, navigate));
    }
  };

  useEffect(() => {
    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      if (
        patientAcknowledgeIndicator === true &&
        patientSign !== null &&
        patientSign !== ""
      )
        setCompleteSubStep(true);
      else setCompleteSubStep(false);
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      if (
        patientAcknowledgeIndicator &&
        (!requireCaregiverSign ||
          (caregiverSign !== null && caregiverSign !== "")) &&
        patientSign !== null &&
        patientSign !== ""
      )
        setCompleteSubStep(true);
      else setCompleteSubStep(false);
    }
  }, [patientAcknowledgeIndicator, caregiverSign, patientSign]);

  const setServiceTypeData = () => {
    switch (clinicalServiceName) {
      case ClinicalServiceTypes.AllergicRhinitis:
        {
          if (
            clinicalServiceObj.initialAssessment.initialAssessmentForm
              .preAssessment.patientAcknowledgeIndicator
          ) {
            setPatientAcknowledgeIndicator(
              clinicalServiceObj.initialAssessment.initialAssessmentForm
                .preAssessment.patientAcknowledgeIndicator
            );
            setPatientSign(
              clinicalServiceObj.initialAssessment.initialAssessmentForm
                .preAssessment.patientSignature
            );
            setConsentChecks(ailmentServices.map((item) => item.label));
          }
        }
        break;
      case ClinicalServiceTypes.MedicationReview:
        {
          if (
            clinicalServiceObj.initialAssessment.initialAssessmentForm
              .preAssessment.patientAcknowledgeIndicator
          ) {
            setPatientAcknowledgeIndicator(
              clinicalServiceObj.initialAssessment.initialAssessmentForm
                .preAssessment.patientAcknowledgeIndicator
            );
            setConsentChecks(medReviewConsentChecks.map((item) => item.label));
            setPatientSign(
              clinicalServiceObj.initialAssessment.initialAssessmentForm
                .preAssessment.patientSignature
            );
            setCaregiverSign(
              clinicalServiceObj.initialAssessment.initialAssessmentForm
                .preAssessment.alternateCaregiverSignature
            );
          }
          if (
            clinicalServiceObj.initialAssessment.initialAssessmentForm
              .preAssessment.attendees.length > 0
          )
            setRequireCaregiverSign(true);
          else setRequireCaregiverSign(false);
        }
        break;
      default:
        break;
    }
  };

  const setServiceTypeView = () => {
    switch (clinicalServiceName) {
      case ClinicalServiceTypes.AllergicRhinitis:
        {
          setConsentTitle(
            "Patient Acknowledgement / Consent for Minor Ailment Services"
          );
          setConsentCheckData(ailmentServices);
          setShowSignature(false);
        }
        break;
      case ClinicalServiceTypes.MedicationReview:
        {
          setConsentTitle(
            "Patient Acknowledgement / Consent for Annual Medication Review"
          );
          setConsentCheckData(medReviewConsentChecks);
          setShowSignature(true);
        }
        break;
      default:
        break;
    }
  };

  const handleChange = (e) => {
    if (e.target.checked) {
      setConsentChecks([...consentChecks, e.target.name]);
    } else {
      setConsentChecks(consentChecks.filter((item) => item !== e.target.name));
    }
  };

  useEffect(() => {
    if (
      consentChecks.length === consentCheckData.length &&
      consentChecks.length > 0
    ) {
      setPatientAcknowledgeIndicator(true);
    } else {
      setPatientAcknowledgeIndicator(false);
    }
  }, [consentChecks]);

  useEffect(() => {
    //only for testing as few wrong data is setting them as 0.
    if (currentStep === 0 && currentSubStep === 0) {
      const object = { currentStep: 1, currentSubStep: 1 };
      dispatch(setDefaultSteps(object));
    }
  }, [currentStep, currentSubStep]);

  //Move back and forward
  const onNext = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      1
    );

    const updatedClinicalServiceObj = {
      preAssessment: {
        patientAcknowledgeIndicator: true,
        ageAlertConfirmationType: alertConfirmation,
        patientSignature: patientSign,
        ageAlertExplaination: alertExplaination,
      },
      currentStep: nextStep,
      currentSubStep: nextSubStep,
      showReferral: showRef,
      serviceSteps: clinicalServiceSteps,
    };

    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      dispatch(updateClinicalService(serviceId, updatedClinicalServiceObj));
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      updatedClinicalServiceObj.preAssessment = {
        ...updatedClinicalServiceObj.preAssessment,
        alternateCaregiverSignature: caregiverSign,
      };
      dispatch(updateMedicationReview(serviceId, updatedClinicalServiceObj));
    }
  };

  const handleAllChecbox = () => {
    setConsentChecks(consentCheckData.map((item) => item.label));
    scrollY("consent-div");
  };

  const disableInBetweenSteps = async (disable = false) => {
    let existingStep = currentStep;
    const updatedServiceSteps = clinicalServiceSteps.map((step, i) => ({
      ...step,
      //disable all the substeps that we are skipping, from next step till documentation step.
      subSteps: step.subSteps.map((subStep) => {
        if (i + 1 > existingStep && i + 1 < MinorAilmentStep.Documentation) {
          return { ...subStep, show: !disable };
        } else return subStep;
      }),
    }));

    await dispatch(setClinicalServiceSteps(updatedServiceSteps));
    setClinicalServiceStepsUpdated(true);
  };

  return (
    <div className="flex flex-col flex-1 gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 h-full">
            <div className="w-full gap-5 h-full">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Consent Form
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="">
                <div className="w-[854px] rounded-[4px] overflow-hidden border border-gray-100">
                  <div
                    className="px-5 py-4 bg-cover bg-center"
                    style={{
                      backgroundImage: `url(/icons/texture-background.png)`,
                    }}
                  >
                    <h3 className="text-body-lg font-bold text-teal-300 ">
                      {consentTitle}
                    </h3>
                  </div>
                  <div
                    id="consent-div"
                    className="flex flex-col gap-6 p-5  text-gray-800 w-[854px] overflow-scroll overflow-x-hidden bg-scroll max-h-[530px]"
                  >
                    <p className="font-semibold text-body-md text-gray-800 ">
                      Complete to continue.{" "}
                      <span
                        onClick={() => handleAllChecbox()}
                        className="cursor-pointer  ml-4 text-black underline underline-offset-2 font-medium"
                      >
                        Select All
                      </span>
                    </p>
                    <div className="relative flex gap-8 flex-col h-auto">
                      {consentCheckData.map((item, index) => (
                        <span
                          key={index}
                          className="flex items-start text-lg font-normal"
                        >
                          <input
                            type="checkbox"
                            id={index}
                            name={item.label}
                            checked={consentChecks.includes(item.label)}
                            onChange={handleChange}
                          />
                          <label
                            htmlFor={index}
                            className="ml-4 text-gray-800  font-normal "
                          >
                            {item.label}
                          </label>
                        </span>
                      ))}
                    </div>
                    {/* {showSignature && ( */}
                    <div className="relative flex gap-6 flex-col h-auto">
                      <p className="text-body-md font-normal text-gray-800">
                        By signing this form, you are acknowledging
                        participation in a {clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis ? "Minor Ailment Assessment" : "Medication Review"} with a pharmacist.
                        <br />
                        <br />
                        Your signature will indicate that you acknowledge the
                        secure exchange of information and your agreement to the
                        {clinicalServiceName ===
                        ClinicalServiceTypes.AllergicRhinitis
                          ? " Minor Ailment Prescribing Service"
                          : " Medication Review Service"}
                        .{requireCaregiverSign}
                      </p>
                      <div className="gap-6 grid grid-cols-12">
                        <div
                          className={`flex flex-col ${
                            requireCaregiverSign ? "col-span-6" : "col-span-12"
                          }`}
                        >
                          <CustomInput
                            name="PatientSignature"
                            label="Patient Signature"
                            placeholder="Patient Name"
                            value={patientSign}
                            onChange={(e) => {
                              setPatientSign(e.target.value);
                              scrollY("consent-div");
                            }}
                            type="text"
                            required
                            autoComplete={"off"}
                            capitalizeFirstLetter={true}
                          />
                          {patientSign !== null && patientSign !== "" && (
                            <div className="border-b-2 pt-6 border-gray-400">
                              <Signature firstName={patientSign}/>
                            </div>
                          )}
                        </div>
                        {requireCaregiverSign && (
                          <div className="flex flex-col col-span-6">
                            <CustomInput
                              name="CaregiverSignature"
                              label="Alternate Caregiver Signature (If applicable)"
                              placeholder={`Alternate Caregiver Name`}
                              value={caregiverSign}
                              onChange={(e) => setCaregiverSign(e.target.value)}
                              type="text"
                              required={requireCaregiverSign}
                              autoComplete={"off"}
                              capitalizeFirstLetter={true}
                            />
                            {caregiverSign !== null && caregiverSign !== "" && (
                              <div className="border-b-2 pt-6 border-gray-400">
                                <Signature firstName={caregiverSign} />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div>
                        <span className="text-teal-300">
                          I agree my printed name will act as my signature{" "}
                          {requireCaregiverSign}
                        </span>
                        <br />
                        <span className="font-bold">
                          "Signature Adoption: Pre-selected Style"
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EndServiceModel
          open={openAgeAlert}
          title="Referral Required"
          content={() => (
            <div className="flex flex-col gap-4">
              <div className="text-body-md font-semibold">
                Age Alert - Less than 2 Years of Age.
              </div>
              <div className="text-body-sm flex flex-col gap-4">
                <p>
                  Allergic Rhinitis is uncommon in the age group as the child needs repeated
                  exposures to the allergen(s) to develop Allergic Rhinitis. Other potential
                  causes of symptoms need to be ruled out.
                </p>
              </div>
            </div>
          )}
          handleClose={() => {
            setContinueService(false);
            setOpenAgeAlert(false);
            setAlertConfirmation(0);
            setAlertExplaination("");
          }}
          handleContinue={(ref, exp) => {
            setAlertConfirmation(
              ref
                ? AlertConfirmationTypes.ContinueWithRefer
                : AlertConfirmationTypes.ContinueWithNoReferral
            );
            setAlertExplaination(exp);
            if (ref !== undefined) {
              setShowRef(ref);
            }
            disableInBetweenSteps(false);
            setOpenAgeAlert(false);
            setContinueService(true);
          }}
          handleEndService={() => {
            setShowRef(true);
            setAlertConfirmation(AlertConfirmationTypes.EndService);
            setAlertExplaination("");
            setOpenAgeAlert(false);
            disableInBetweenSteps(true);
          }}
        />
      </div>
      <ConfirmationModalNew
        open={openDeleteServiceForMedical}
        title={`${clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis ? "Minor Ailment" : "Medication Review"}`}
        className="!w-[630px] !max-w-2xl"
        content={() => (
          <div className="">
            <p className="text-body-md text-left text-gray-800">
            By selecting <span className="font-semibold text-teal-300">Cancel</span>, you will return to the <span className="font-semibold text-teal-300">Clinical Services</span> homepage 
            to select a different option.
            </p>
            <br />
            <p className="text-body-md text-left text-gray-800">
              The current assessment will be discarded if you choose a new clinical service.
            </p>
          </div>
        )}
        type={"primary"}
        confirmText={"Cancel Service"}
        cancelText={"Continue"}
        verticalButtons={false}
        handleClose={() => {
          setOpenDeleteServiceForMedical(false);
        }}
        onCross={() => setOpenDeleteServiceForMedical(false)}
        confirmAction={() => {
          setOpenDeleteServiceForMedical(false);
          deleteService();
        }}
      />
      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Cancel Service"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => setOpenDeleteServiceForMedical(true)}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] ${
              !completeSubStep && "opacity-40 pointer-events-none"
            }`}
            onClick={() => {
              if (
                calculateAgeYear(patient.dateOfBirth) < 2 &&
                clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
              ) {
                setOpenAgeAlert(true);
              } else {
                onNext();
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default ConsentForm;
